export interface PasswordScore {
  invalidChars: string | undefined;
  length: boolean;
  upperLowerCase: boolean;
  number: boolean;
  special: boolean;
}

export function validateForLength(text: string) {
  return text.length >= 12;
}

export function validateForUpperLowerCase(text: string) {
  const ucMatches = text.match(/[A-Z]/g);
  const lcMatches = text.match(/[a-z]/g);
  return ucMatches !== null && lcMatches !== null && ucMatches.length > 0 && lcMatches.length > 0;
}

export function validateForNumber(text: string) {
  const matches = text.match(/\d+/g);

  return matches != null && matches.length > 0;
}

export function validateForSpecialMatches(text: string) {
  const matches = text.match(/[^A-Za-z0-9<>\x20\x3C\x3E\s]/g); //[^A-Za-z0-9][¡”¥¢‰¶\{}≠¿`^’—·„•$€£\x21-\xFF]

  return matches != null && matches.length > 0;
}

export function getInvalidChars(text: string = '') {
  const invalid = text.match(/[^¡”¥¢‰¶{}≠¿`^’—·„•$€£\x21-\x3B\x3D\x3F-\xFF]/g);
  if (invalid != null) {
    const invalidChars = Array.from(new Set(invalid));
    if (invalidChars.includes(' ')) {
      const i = invalidChars.indexOf(' ');
      invalidChars[i] = "' '";
    }
    return invalidChars.join(', ');
  }
}

export function getPasswordScore(text: string = ''): PasswordScore {
  const invalidChars = getInvalidChars(text);

  return {
    invalidChars: invalidChars,
    length: validateForLength(text),
    upperLowerCase: validateForUpperLowerCase(text),
    number: validateForNumber(text),
    special: validateForSpecialMatches(text),
  };
}
